function Projects() {
  return (
    <div className="display ml-5 m-5 mr-5">
      <div className="w-100">
        <h1 className="white sub" id="mywork">
          My Work
        </h1>

        <div className="display card">
          <div className="display-left w-30 mr-5">
            <h1 className="timeframe primary ta-left">
              January 2024 - Current
            </h1>
          </div>
          <div className="display-left w-70">
            <div className="w-100 ta-left">
              <h1 className="exp-title primary">
                <a
                  className="primary"
                  href="https://www.unwsp.edu"
                  target="_blank"
                >
                  University of Northwestern St. Paul - Software Developer
                  <i class="fa fa-light fa-arrow-up-right-from-square primary ml-5"></i>
                </a>
              </h1>
              <h1 className="exp-desc white">
                Manage all custom web applications needed for various university
                functions. Have pushed several apps from idea to production
                within my time here. Handled interface design and development
                for 4 different web applications.
              </h1>
              <div className="display-wrap w-100 m-5">
                <div className="tech-blob secondary mr-5">JavaScript</div>
                <div className="tech-blob secondary mr-5">HTML</div>
                <div className="tech-blob secondary mr-5">CSS</div>
                <div className="tech-blob secondary mr-5">PHP (Laravel)</div>
                <div className="tech-blob secondary mr-5">VueJS</div>
                <div className="tech-blob secondary mr-5">PL/SQL</div>
              </div>
            </div>
          </div>
        </div>

        <div className="display card">
          <div className="display-left w-30 mr-5">
            <h1 className="timeframe primary ta-left">May 2025</h1>
          </div>
          <div className="display-left w-70">
            <div className="w-100 ta-left">
              <h1 className="exp-title primary">
                <a
                  className="primary"
                  href="https://qb.ryanmau.com"
                  target="_blank"
                >
                  2024 QB Efficiency Dashboard - Personal Project
                  <i class="fa fa-light fa-arrow-up-right-from-square primary ml-5"></i>
                </a>
              </h1>
              <h1 className="exp-desc white">
                Built a simple dashboard to analyze quarterback efficiency data
                for the 2024-2025 NFL season.
              </h1>
              <div className="display-wrap w-100 m-5">
                <div className="tech-blob secondary mr-5">JavaScript</div>
                <div className="tech-blob secondary mr-5">HTML</div>
                <div className="tech-blob secondary mr-5">CSS</div>
                <div className="tech-blob secondary mr-5">Java</div>
                <div className="tech-blob secondary mr-5">Spring</div>
                <div className="tech-blob secondary mr-5">MySQL</div>
              </div>
            </div>
          </div>
        </div>

        <div className="display card">
          <div className="display-left w-30 mr-5">
            <h1 className="timeframe primary ta-left">August 2023 - Current</h1>
          </div>
          <div className="display-left w-70">
            <div className="w-100 ta-left">
              <h1 className="exp-title primary">
                <a
                  className="primary"
                  href="https://www.underbite.app"
                  target="_blank"
                >
                  Underbite - Founder/Creator
                  <i class="fa fa-light fa-arrow-up-right-from-square primary ml-5"></i>
                </a>
              </h1>
              <h1 className="exp-desc white">
                Created a veterinary dental charting software called Underbite.
                A cloud-based platform which allows veterinarians to create,
                edit, and export dental charts seemlessly.
              </h1>
              <div className="display-wrap w-100 m-5">
                <div className="tech-blob secondary mr-5">Java</div>
                <div className="tech-blob secondary mr-5">JavaScript</div>
                <div className="tech-blob secondary mr-5">HTML</div>
                <div className="tech-blob secondary mr-5">CSS</div>
                <div className="tech-blob secondary mr-5">Thymeleaf</div>
                <div className="tech-blob secondary mr-5">Spring</div>
                <div className="tech-blob secondary mr-5">htmx</div>
                <div className="tech-blob secondary mr-5">MySQL</div>
              </div>
            </div>
          </div>
        </div>

        <div className="display card">
          <div className="display-left w-30 mr-5">
            <h1 className="timeframe primary ta-left">
              January 2023 - June 2023
            </h1>
          </div>
          <div className="display-left w-70">
            <div className="w-100 ta-left">
              <h1 className="exp-title primary">
                <a
                  className="primary"
                  href="https://www.team2.com"
                  target="_blank"
                >
                  Team2 - Junior Developer Internship
                  <i class="fa fa-light fa-arrow-up-right-from-square primary ml-5"></i>
                </a>
              </h1>
              <h1 className="exp-desc white">
                Developed and styled new frontend functionality within a
                custom-built system infrastructure. Responsible for connecting
                backend data to the frontend, and building a user-friendly UI.
              </h1>
              <div className="display-wrap w-100 m-5">
                <div className="tech-blob secondary mr-5">JavaScript</div>
                <div className="tech-blob secondary mr-5">HTML</div>
                <div className="tech-blob secondary mr-5">CSS</div>
                <div className="tech-blob secondary mr-5">PHP</div>
                <div className="tech-blob secondary mr-5">JQuery</div>
                <div className="tech-blob secondary mr-5">Bootstrap</div>
                <div className="tech-blob secondary mr-5">Agile</div>
              </div>
            </div>
          </div>
        </div>

        <div className="display card">
          <div className="display-left w-30 mr-5">
            <h1 className="timeframe primary ta-left">
              November 2022 - May 2023
            </h1>
          </div>
          <div className="display-left w-70">
            <div className="w-100 ta-left">
              <h1 className="exp-title primary">
                <a
                  className="primary"
                  href="https://vet.ryanmau.com"
                  target="_blank"
                >
                  Vet Practice Management System
                  <i class="fa fa-light fa-arrow-up-right-from-square primary ml-5"></i>
                </a>
              </h1>
              <h1 className="exp-desc white">
                Built a cloud-based veterinary practice management system which
                allows veterinary clinics to manage their clinic data on a
                singular platform. This was my senior project for university.
              </h1>
              <div className="display-wrap w-100 m-5">
                <div className="tech-blob secondary mr-5">Spring</div>
                <div className="tech-blob secondary mr-5">SolidJS</div>
                <div className="tech-blob secondary mr-5">TypeScript</div>
                <div className="tech-blob secondary mr-5">HTML</div>
                <div className="tech-blob secondary mr-5">CSS</div>
                <div className="tech-blob secondary mr-5">MySQL</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Projects;
